import { render, staticRenderFns } from "./VantContrastCreatePop.vue?vue&type=template&id=ecf2f8fe&"
import script from "./VantContrastCreatePop.vue?vue&type=script&lang=js&"
export * from "./VantContrastCreatePop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports